import { render, staticRenderFns } from "./InsuranceBridgeRecipe.vue?vue&type=template&id=a5764cfa&scoped=true&"
import script from "./InsuranceBridgeRecipe.vue?vue&type=script&lang=js&"
export * from "./InsuranceBridgeRecipe.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceBridgeRecipe.vue?vue&type=style&index=0&id=a5764cfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5764cfa",
  null
  
)

export default component.exports